import { render, staticRenderFns } from "./SubscriptionPackagesDialog.vue?vue&type=template&id=56b731a8"
import script from "./SubscriptionPackagesDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionPackagesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports